import { Modal, Form, Select, Alert } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item
const SelectOption = Select.Option

function AccountPlanComponent(props) {
  const { form, record, loading, ...rest } = props
  const { getFieldDecorator } = form

  const plans = record != undefined && record.plans != undefined
    ? record.plans
    : []

  return (
    <Modal
      centered
      title="Change the user plan"
      okText="Change"
      okButtonProps={{ loading: props.loading }}
      {...rest}>
      <Form layout="vertical">
        <FormItem label="New plan" hasFeedback>
          {getFieldDecorator('accountPlan', {
            rules: [
              {
                required: true,
              },
            ],
          })(
            <Select placeholder="Select a plan">
              {plans.map(plan => (
                <SelectOption key={plan.id}>{plan.name}</SelectOption>
              ))}
            </Select>
          )}
        </FormItem>
      </Form>
      <Alert
        message="Careful!"
        description="This action will affect all the chatbots that have this account as payment account!"
        type="warning"
        showIcon
      />
    </Modal>
  )
}

export const AccountPlanModal = Form.create({
  mapPropsToFields: ({ record }) => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(AccountPlanComponent))

AccountPlanComponent.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  loading: PropTypes.bool,
  plans: PropTypes.array,
}
